<div class="reward-content-item-lc" [class.removed-user]="inactiveUser">
  <oph-avatar [user]="user" [size]="24"></oph-avatar>
  <span class="reward-username">{{ user?.username }}</span>
</div>

<ng-content></ng-content>
